module.exports = __webpack_public_path__ + "img/icon_xiaba_normal@2x.46ab23ff.png";